/* PawerLab — cart drawer (custom UpCart replacement)
   No dependencies. Talks to the Shopify AJAX Cart API only.

   Extends reference/assets/pawerlab.js's cart logic (open/close, focus
   trap, render, qty +/-) with three additions: global add-to-cart form
   interception (so every existing PDP hero's plain <form action="/cart/
   add"> form starts opening this drawer instead of navigating to /cart,
   with zero changes needed in those 6 files), cart notes, a discount
   code field, and native-recommendations-driven upsells. */

(function () {
  'use strict';

  var drw = document.getElementById('pwcart-drw');
  var ovl = document.getElementById('pwcart-ovl');
  if (!drw || !ovl) return;

  var THRESHOLD = parseInt(drw.dataset.threshold, 10) || 4000;
  var FORMAT = drw.dataset.moneyFormat || '${{amount}}';
  var itemsEl = document.getElementById('pwcart-items');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- money ---------- */

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FORMAT
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- drawer open/close ---------- */

  var lastFocus = null;
  var isClosing = false;
  var CLOSE_MS = 280; // matches .pwcart-drw.is-closing's animation-duration
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openCart() {
    isClosing = false;
    drw.classList.remove('is-closing');
    ovl.classList.remove('is-closing');
    lastFocus = document.activeElement;
    drw.hidden = false;
    ovl.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = drw.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  /* Plays the reverse slide/fade (see the .is-closing keyframes in
     pawer-cart-drawer.liquid) and only sets hidden once it's actually
     finished, instead of vanishing instantly the moment hidden flips —
     that was the "hard disappear" bug. Guarded with isClosing so a
     second Escape/close click mid-animation doesn't restart or double-
     fire the timeout. */
  function closeCart() {
    if (drw.hidden || isClosing) return;
    isClosing = true;

    if (reduceMotion) {
      finishClose();
      return;
    }

    drw.classList.add('is-closing');
    ovl.classList.add('is-closing');
    setTimeout(finishClose, CLOSE_MS);
  }

  function finishClose() {
    drw.hidden = true;
    ovl.hidden = true;
    drw.classList.remove('is-closing');
    ovl.classList.remove('is-closing');
    document.body.style.overflow = '';
    isClosing = false;
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drw.hidden) closeCart();
  });

  drw.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = drw.querySelectorAll('button, [href], input, select, textarea');
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- render ---------- */

  /* Fired only from the two add-to-cart paths below, not from render()
     itself — render() also runs on qty decrement/remove, which
     shouldn't pulse. See header.liquid for the .js-pulse keyframe. */
  function pulseCartCount() {
    document.querySelectorAll('.header-cart-count').forEach(function (el) {
      el.classList.remove('js-pulse');
      void el.offsetWidth; // restart the animation if it's already mid-pulse
      el.classList.add('js-pulse');
    });
  }

  /* If pawer-cart-main.js is loaded (i.e. the shopper is on /cart, or
     adding from a cross-sell card there), tell it to re-render its
     lines — otherwise an add from the drawer's upsell row would leave
     the full cart page stale until a manual refresh. */
  function notifyCartPage() {
    if (window.PawerLabCartPage && window.PawerLabCartPage.reload) {
      window.PawerLabCartPage.reload();
    }
  }

  function render(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      /* Always just the bare number now — the desktop badge's "(" ")"
         moved out to static markup in header.liquid (see that file's
         comment): something else on the page was intermittently
         overwriting this element's textContent directly (surviving a
         hard refresh but not a soft page transition, which is what
         gave it away — confirmed live this file's own render() was
         correct in 15+ direct tests and never the actual culprit).
         Parens living outside this span means they can't be stripped
         by whatever that other script is, whatever it turns out to be. */
      el.textContent = cart.item_count;
      if (el.classList.contains('pw-cart-badge')) el.hidden = cart.item_count === 0;
    });

    var subEl = document.getElementById('pwcart-sub');
    if (subEl) subEl.textContent = money(cart.total_price);

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var line = i + 1;
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_120x$1') + '" alt="" loading="lazy" />'
          : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? ' &middot; ' + escapeHtml(item.variant_title)
          : '';
        var title = escapeHtml(item.product_title);
        return '<div class="li" data-line="' + line + '">' + img +
          '<div class="li__info"><p class="li__t">' + title + '</p>' +
          '<p class="li__p">' + money(item.final_price) + variant + '</p></div>' +
          '<div class="qty">' +
            '<button data-q="-" data-line="' + line + '" aria-label="Remove one ' + title + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-q="+" data-line="' + line + '" aria-label="Add one ' + title + '">+</button>' +
          '</div></div>';
      }).join('');
    }

    var remaining = THRESHOLD - cart.total_price;
    var pct = Math.min(100, (cart.total_price / THRESHOLD) * 100);
    var barEl = document.getElementById('pwcart-bar');
    var msgEl = document.getElementById('pwcart-shipMsg');
    if (barEl) barEl.style.width = pct + '%';
    if (msgEl) {
      msgEl.textContent = remaining > 0
        ? 'Add ' + money(remaining) + ' for free shipping'
        : 'Free shipping unlocked';
    }

    refreshUpsells(cart);
    enrichSubscriptionButtons(cart);
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  /* Exposed so pawer-cart-main.js can hand this drawer a cart object it
     already fetched (keeping the drawer in step without a second
     network round trip), and so this file can tell the full cart page
     to refresh itself below, if it's the one open. */
  window.PawerLabCart = { render: render, refresh: refresh };

  /* ---------- subscription upgrade / downgrade ----------
     Confirmed live (via /products/<handle>.js) that Appstle registers
     itself as a real Shopify selling-plan app (app_id "appstle") rather
     than a fully custom checkout mechanism — so switching a line
     between one-time and subscription is just the standard Cart AJAX
     API's cart/change.js with a selling_plan param (a real plan id to
     upgrade, null to revert), no Appstle-specific API needed.

     A line already on a plan doesn't need the async check at all — we
     already know from cart.js. Only the "is a plan available" question
     (for a not-yet-subscribed line) needs the extra product.js fetch,
     since cart.js line items don't carry that. Downgrade replaced
     "delete and re-add" as the only way back to one-time — that lost
     the line's cart position and made an accidental upgrade-click hard
     to undo. */

  function enrichSubscriptionButtons(cart) {
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var li = itemsEl.querySelector('.li[data-line="' + line + '"]');
      if (!li) return;
      var info = li.querySelector('.li__info');
      if (!info || info.querySelector('.li__sub')) return;

      if (item.selling_plan_allocation) {
        var downBtn = document.createElement('button');
        downBtn.type = 'button';
        downBtn.className = 'li__sub';
        downBtn.dataset.downgradeSub = '1';
        downBtn.dataset.line = line;
        downBtn.textContent = 'Switch to one-time purchase';
        info.appendChild(downBtn);
        return;
      }

      fetch(root + 'products/' + item.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var group = product.selling_plan_groups && product.selling_plan_groups[0];
          var plan = group && group.selling_plans && group.selling_plans[0];
          if (!plan) return;
          if (info.querySelector('.li__sub')) return; // cart may have re-rendered while this was in flight

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'li__sub';
          btn.dataset.upgradeSub = plan.id;
          btn.dataset.line = line;
          btn.textContent = 'Upgrade to subscription — save an extra 5%';
          info.appendChild(btn);
        })
        .catch(function (err) { console.error('[PawerLab] subscription check failed:', err); });
    });
  }

  itemsEl.addEventListener('click', function (e) {
    var upBtn = e.target.closest('[data-upgrade-sub]');
    var downBtn = e.target.closest('[data-downgrade-sub]');
    var btn = upBtn || downBtn;
    if (!btn) return;

    var line = parseInt(btn.dataset.line, 10);
    var sellingPlan = upBtn ? upBtn.dataset.upgradeSub : null;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Switching…';

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, selling_plan: sellingPlan })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || cart.message);
        render(cart);
        notifyCartPage();
      })
      .catch(function (err) {
        console.error('[PawerLab] subscription switch failed:', err);
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* ---------- add to cart: global form interception ----------
     Every existing PDP hero (pawer-wipes-hero.liquid etc.) already has
     a plain <form action="{{ routes.cart_add_url }}"> — this catches
     ALL of them site-wide without touching those files. Appstle's own
     subscription widget mounts its own separate form/JS elsewhere in
     the same section (see the "Appstle app block renders here"
     comments in every hero file) and is explicitly left alone —
     skipped here via the data-cart-skip / [class*="appstle"] guard so
     its own submission flow is never intercepted. */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.hasAttribute('data-cart-skip')) return;
    if (form.closest('[class*="appstle" i], [id*="appstle" i]')) return;
    if (form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var originalLabel = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return refresh();
      })
      .then(function () { pulseCartCount(); notifyCartPage(); openCart(); })
      .catch(function (err) {
        console.error('[PawerLab] add to cart failed:', err);
        if (btn) btn.textContent = 'Could not add';
        setTimeout(function () { if (btn) btn.textContent = originalLabel; }, 2200);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (btn.textContent === 'Adding…') btn.textContent = originalLabel;
        }
      });
  });

  /* [data-add] buttons — used by the drawer's own upsell "Add" buttons
     below, same convention as reference/assets/pawerlab.js. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.dataset.add;
    if (!id) return;

    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return refresh();
      })
      .then(function () { pulseCartCount(); notifyCartPage(); })
      .catch(function (err) {
        console.error('[PawerLab] add to cart failed:', err);
        btn.textContent = 'Could not add';
        setTimeout(function () { btn.textContent = label; }, 2200);
      })
      .finally(function () {
        btn.disabled = false;
        if (btn.textContent === 'Adding…') btn.textContent = label;
      });
  });

  /* ---------- quantity / remove ---------- */

  itemsEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]');
    if (!b) return;

    var line = parseInt(b.dataset.line, 10);
    var current = parseInt(b.parentElement.querySelector('span').textContent, 10);
    var next = b.dataset.q === '+' ? current + 1 : current - 1;

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, next) })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (err) { console.error('[PawerLab] cart update failed:', err); });
  });

  /* ---------- cart note ----------
     Saved on blur (not every keystroke) — matches the theme's own
     debounce-nothing-unnecessarily convention elsewhere in this
     project (e.g. the price-sync snippet only fires on real events). */

  var noteEl = document.getElementById('pwcart-note');
  if (noteEl) {
    noteEl.addEventListener('blur', function () {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: noteEl.value })
      }).catch(function (err) { console.error('[PawerLab] cart note failed:', err); });
    });
  }

  /* ---------- discount code ----------
     Shopify's Cart AJAX API has no endpoint to apply a discount code
     without a full page load — /discount/<code> is the only native
     mechanism, and it redirects. This one action is a real page
     navigation; everything else in the drawer stays instant. */

  var discInput = document.getElementById('pwcart-disc-input');
  var discApply = document.getElementById('pwcart-disc-apply');
  if (discInput && discApply) {
    discApply.addEventListener('click', function () {
      var code = discInput.value.trim();
      if (!code) return;
      window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
    discInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); discApply.click(); }
    });
  }

  /* ---------- upsells (auto-playing slideshow) ----------
     Shopify's native Product Recommendations endpoint, keyed off the
     cart's first line item. No merchant configuration needed — this is
     the same "automatic, not curated" tradeoff called out when this
     drawer was scoped: no admin dashboard, no ML ranking, just
     Shopify's own related-products signal.

     Shows one product at a time and auto-advances through the full
     result set on a timer (was a static row of 3) — limit bumped to
     10, Shopify's max for this endpoint, so there's an actual slideshow
     to cycle through rather than 3 items looping pointlessly. Dots
     underneath show position/count. Restarts cleanly on every cart
     change (interval cleared first) so re-adding never stacks timers. */

  var upsellWrap = document.getElementById('pwcart-upsell');
  var upsellItems = document.getElementById('pwcart-upsell-items');
  var upsellDots = document.getElementById('pwcart-upsell-dots');
  var upsellProducts = [];
  var upsellIndex = 0;
  var upsellTimer = null;
  var UPSELL_MS = 3500;

  function renderUpsellSlide() {
    var p = upsellProducts[upsellIndex];
    if (!p) return;
    var variant = p.variants && p.variants[0];
    if (!variant) return;

    var img = p.featured_image
      ? '<img src="' + p.featured_image + '" alt="" loading="lazy" />'
      : '';
    upsellItems.innerHTML = '<div class="up">' + img +
      '<div><p class="up__t">' + escapeHtml(p.title) + '</p>' +
      '<p class="up__p">' + money(variant.price) + '</p></div>' +
      '<button class="up__add" data-add="' + variant.id + '">Add</button>' +
      '</div>';

    if (upsellDots) {
      upsellDots.innerHTML = upsellProducts.map(function (_, i) {
        return '<i class="' + (i === upsellIndex ? 'is-on' : '') + '"></i>';
      }).join('');
    }
  }

  function stopUpsellCarousel() {
    if (upsellTimer) { clearInterval(upsellTimer); upsellTimer = null; }
  }

  function startUpsellCarousel() {
    stopUpsellCarousel();
    if (upsellProducts.length < 2) return;
    if (reduceMotion) return; // reduced motion: show one product, don't auto-cycle
    upsellTimer = setInterval(function () {
      upsellIndex = (upsellIndex + 1) % upsellProducts.length;
      renderUpsellSlide();
    }, UPSELL_MS);
  }

  /* Manual nav (arrows + swipe) — wraps around either direction, and
     restarts the auto-advance timer afterward (via startUpsellCarousel,
     which clears the old one first) so it doesn't immediately fight a
     manual choice by auto-advancing a beat later. Reduced-motion users
     still get manual nav; only the automatic timer is skipped for them. */
  function goToUpsellSlide(newIndex) {
    if (!upsellProducts.length) return;
    upsellIndex = ((newIndex % upsellProducts.length) + upsellProducts.length) % upsellProducts.length;
    renderUpsellSlide();
    startUpsellCarousel();
  }

  var upsellPrevBtn = document.getElementById('pwcart-upsell-prev');
  var upsellNextBtn = document.getElementById('pwcart-upsell-next');
  if (upsellPrevBtn) upsellPrevBtn.addEventListener('click', function () { goToUpsellSlide(upsellIndex - 1); });
  if (upsellNextBtn) upsellNextBtn.addEventListener('click', function () { goToUpsellSlide(upsellIndex + 1); });

  /* Swipe — touchstart/touchend only (no touchmove tracking/inertia),
     matching the drawer's generally minimal-JS approach elsewhere.
     touch-action:pan-y on the slide's own CSS lets vertical drawer
     scroll pass through untouched while this handles horizontal. */
  var upsellTouchX = null;
  var UPSELL_SWIPE_PX = 40;
  upsellItems.addEventListener('touchstart', function (e) {
    upsellTouchX = e.touches[0].clientX;
  }, { passive: true });
  upsellItems.addEventListener('touchend', function (e) {
    if (upsellTouchX === null) return;
    var deltaX = e.changedTouches[0].clientX - upsellTouchX;
    upsellTouchX = null;
    if (deltaX > UPSELL_SWIPE_PX) goToUpsellSlide(upsellIndex - 1);
    else if (deltaX < -UPSELL_SWIPE_PX) goToUpsellSlide(upsellIndex + 1);
  }, { passive: true });

  function refreshUpsells(cart) {
    if (!upsellWrap || !upsellItems) return;
    stopUpsellCarousel();
    if (!cart.items.length) { upsellWrap.hidden = true; return; }

    var cartProductIds = cart.items.map(function (i) { return i.product_id; });
    var seedId = cart.items[0].product_id;

    fetch(root + 'recommendations/products.json?product_id=' + seedId + '&limit=10&intent=related', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        upsellProducts = (res.products || []).filter(function (p) {
          return cartProductIds.indexOf(p.id) === -1 && p.variants && p.variants[0];
        });
        upsellIndex = 0;

        if (!upsellProducts.length) { upsellWrap.hidden = true; return; }

        renderUpsellSlide();
        upsellWrap.hidden = false;
        startUpsellCarousel();
      })
      .catch(function (err) {
        console.error('[PawerLab] upsell fetch failed:', err);
        upsellWrap.hidden = true;
      });
  }
})();
